import React, { useState } from "react";
import { Box, Alert, Tabs, Tab } from "@mui/material";

import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

import OutletTab from "./Tabs/OutletTab";
import OverviewTab from "./Tabs/OverviewTab";
import QogitaWatchlistSection from "./Tabs/QogitaWatchlistSection";
import NexaliaTab from "./Tabs/NexaliaTab";
import GodelTab from "./Tabs/GodelTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`price-alerts-tabpanel-${index}`}
    aria-labelledby={`price-alerts-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

const PriceAlertsPage = () => {
  const [tabValue, setTabValue] = useState(1);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setError(null);
    setSuccess(null);
  };

  return (
    <DashboardLayout>
      <MDBox>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <MDTypography variant="h4" fontWeight="medium" color="dark" mb={3}>
          Price Alerts
        </MDTypography>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Overview" />
            <Tab label="Outlet Monitor" />
            <Tab label="Qogita Watchlist" />
            <Tab label="Nexalia" />
            <Tab label="Godel" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <OverviewTab />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <OutletTab />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <QogitaWatchlistSection />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <NexaliaTab />
        </TabPanel>

        <TabPanel value={tabValue} index={4}>
          <GodelTab />
        </TabPanel>
      </MDBox>
    </DashboardLayout>
  );
};

export default PriceAlertsPage;
